import { defineMessages } from 'react-intl';

export const messages: {
	doneButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingContentBulkOperations: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionContentBulkOperations: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingContentCustomizeBar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionContentCustomizeBar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingContentSeeSubtasks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionContentSeeSubtasks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingContentFindWork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionContentFindWork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timelineImprovmentsLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	doneButton: {
		id: 'jira-software-timeline-m3.modal.doneButton',
		defaultMessage: 'Done',
		description: 'Dismiss button for the software timeline M3 onboarding modal',
	},
	closeButton: {
		id: 'jira-software-timeline-m3.modal.closeButton',
		defaultMessage: 'Close',
		description: 'Close button for the software timeline M3 onboarding modal',
	},
	nextButton: {
		id: 'jira-software-timeline-m3.modal.nextButton',
		defaultMessage: 'Next',
		description: 'Next button for the software timeline M3 onboarding modal',
	},
	headingContentBulkOperations: {
		id: 'jira-software-timeline-m3.headingContentBulkOperations',
		defaultMessage: 'Reduce repetitive work',
		description:
			'Heading for Reduce repetitive work section in the bulk operations onboarding modal',
	},
	descriptionContentBulkOperations: {
		id: 'jira-software-timeline-m3.descriptionContentBulkOperations',
		defaultMessage: 'Edit, move, transition, watch or delete multiple work items simultaneously.',
		description: 'Description for the bulk operations onboarding modal',
	},
	headingContentCustomizeBar: {
		id: 'jira-software-timeline-m3.headingContentCustomizeBar',
		defaultMessage: 'Customize bars using colors',
		description: 'Heading for Customize bars using colors section in the onboarding modal',
	},
	descriptionContentCustomizeBar: {
		id: 'jira-software-timeline-m3.descriptionContentCustomizeBar',
		defaultMessage: 'Make specific work items easier to scan or highlight as a priority.',
		description: 'Description for the customize bars in the onboarding modal',
	},
	headingContentSeeSubtasks: {
		id: 'jira-software-timeline-m3.headingContentSeeSubtasks',
		defaultMessage: 'See subtasks at a glance',
		description: 'Heading for See subtasks at a glance section in the onboarding modal',
	},
	descriptionContentSeeSubtasks: {
		id: 'jira-software-timeline-m3.descriptionContentSeeSubtasks',
		defaultMessage: 'They now appear under epics.',
		description: 'Description for the see subtasks section in the onboarding modal',
	},
	headingContentFindWork: {
		id: 'jira-software-timeline-m3.headingContentFindWork',
		defaultMessage: 'Quickly find work items',
		description: 'Heading for Quickly find work items section in the onboarding modal',
	},
	descriptionContentFindWork: {
		id: 'jira-software-timeline-m3.descriptionContentFindWork',
		defaultMessage: 'Search, filter and group work items.',
		description: 'Description for the find work section in the onboarding modal',
	},
	timelineImprovmentsLink: {
		id: 'jira-software-timeline-m3.timelineImprovmentsLink',
		defaultMessage: 'Read about Timeline improvements.',
		description: 'Link text for the Timeline improvements article in the onboarding modal',
	},
});
